import { vars } from "@common/styles";
import styled from "styled-components";

export const MetricRowWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1.6rem;
`;

export const ScoreAndInput = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  flex-shrink: 0;
`;

export const DescriptionColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex: 1;
  justify-content: center;
  align-self: stretch;
`;

export const DescText = styled.p`
  font-size: 1.4rem;
  line-height: 2rem;
  color: ${vars.colors.grey50};
  margin: 0;
`;

export const ErrorText = styled.p`
  font-size: 1.3rem;
  line-height: 1.8rem;
  color: ${vars.colors.red};
  margin: 0;
`;
